import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function FooterBottom() {
  return (
    <div>
      <section className="footer">
        <Container>
          <div className="m-fbs">
            <div className="footer-1 py-2">
              <Link className="txt-5" to="/privacy-policy">Privacy Policy</Link>
              <Link className="txt-5" to="/terms-&-conditions">Terms & Condition</Link>
              {/* <Link className="txt-5" to="/exchange-policy">Exchange Policy </Link>
              <Link className="txt-5" to="/cancellation-policy">Cancelation Policy </Link> */}
              <Link className="txt-5" to="/return-policy">Return Policy</Link>
            </div>
          </div>
          
        </Container>
      </section>
      <section className="footer">
        <Container>
          <div className="px-5 pt-2">
         
      <p className="txt-6 mb-0 py-2">Copyrights @ {new Date().getFullYear()} <strong>VNEXT IT Peripheral
              Solutions Private Limited</strong> designed & developed by <a style={{color:"#000",textDecoration:"none"}} href="https://www.thetechhorse.com/">The TechHorse</a></p>

          </div>
        </Container>
      </section>
    </div>
  );
}
